module.exports = __webpack_public_path__ + "7b54ee46.svg";